import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/hidden-quests', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/admin/hidden-quests', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/hidden-quests', {
      data: payload,
    })
    return response
  },
  async getList(params) {
    let response = await api.get('/admin/hidden-quests', {
      params,
    })
    return response
  },
  async get(params) {
    let response = await api.get('/admin/hidden-quests/detail', {
      params,
    })
    return response.data.data.document || null
  },
}
